import { SiteStore } from '@wix/wixstores-client-storefront-sdk';
import {
  CURRENCY_HEADER_NAME,
  MULTI_LANG_HEADER_NAME,
} from '@wix/wixstores-client-core';
import { getApiBaseUrl } from './utils';
import { DEFAULT_CURRENCY_HEADER, INSTANCE_PARAM, SPECS } from '../constants';
import {
  getCurrencyHeader as getCurrencyHeaderValue,
  getQueryParam,
} from './headers';

export function getSDKAuthAndHost(
  siteStore: SiteStore,
  options?: { additionalHeaders?: Record<string, string> },
) {
  return {
    auth: {
      getAuthHeaders: () => {
        const currencyHeader = getCurrency(siteStore);
        const multiLangHeader = siteStore.getMultiLangHeader();
        return {
          headers: {
            Authorization: getInstance(siteStore),
            ...(currencyHeader
              ? { [CURRENCY_HEADER_NAME]: currencyHeader }
              : {}),
            ...(multiLangHeader
              ? { [MULTI_LANG_HEADER_NAME]: multiLangHeader }
              : {}),
            ...options?.additionalHeaders,
          },
        };
      },
    },
    host: {
      apiBaseUrl: getApiBaseUrl(siteStore.isSSR(), siteStore.location.baseUrl),
    },
  };
}

export function getCurrency(siteStore: SiteStore) {
  return siteStore.experiments.enabled(SPECS.AlwaysSendCurrencyHeader)
    ? getCurrencyHeaderValue(siteStore.wixCodeApi) || DEFAULT_CURRENCY_HEADER
    : siteStore.getCurrencyHeader();
}

function getInstance(siteStore: SiteStore) {
  const overrideInstance = getQueryParam(siteStore.wixCodeApi, INSTANCE_PARAM);
  return overrideInstance ?? siteStore.instanceManager.getInstance();
}
